import { render, staticRenderFns } from "./PopulationAnalysis.vue?vue&type=template&id=286a8052&"
import script from "./PopulationAnalysis.vue?vue&type=script&lang=js&"
export * from "./PopulationAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./PopulationAnalysis.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports